import { render, staticRenderFns } from "./FaceCaptureDialog.vue?vue&type=template&id=f19d49b4&scoped=true"
import script from "./FaceCaptureDialog.vue?vue&type=script&lang=js"
export * from "./FaceCaptureDialog.vue?vue&type=script&lang=js"
import style0 from "./FaceCaptureDialog.vue?vue&type=style&index=0&id=f19d49b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19d49b4",
  null
  
)

export default component.exports